import { useTranslation } from "react-i18next";

export const TiposMovimientos = () => {
  const { t } = useTranslation();

  const draft = [{
    tipo: "operativo", 
    color: "#01b7c4"
  },
  {
    tipo: "justificacion",
    color: "#c4046b"
  },
  {
    tipo: "fuera de servicio",
    color: "#d6707c"
  }];

  return (
    <section style={{ 
      width: "100%", 
      display: "flex",
      justifyContent: "center", 
      alignItems: "center", 
      gap: "5px"
    }}>
      {draft.map((item) => (
        <section 
          key={item.tipo} 
          style={{ 
            display: "flex", 
            alignItems: "center", 
            gap: "10px",
            marginInline: "35px"
          }}>
          <span 
            style={{ 
              width: "10px", 
              height: "10px", 
              borderRadius: "100%", 
              backgroundColor: item.color 
            }}
          />
          <p>{t(item.tipo)}</p>
        </section>
      ))}
    </section>
  )
}